import { render } from "./CdaDoc.vue?vue&type=template&id=3dabab96&scoped=true"
import script from "./CdaDoc.vue?vue&type=script&lang=js"
export * from "./CdaDoc.vue?vue&type=script&lang=js"

import "./CdaDoc.vue?vue&type=style&index=0&id=3dabab96&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dabab96"]])

export default __exports__